import { StateSchema } from 'app/config/storeConfig/types';
import { BookingInfoStacks } from '../types';

export const getOpenedStack = (state: StateSchema): Nullable<BookingInfoStacks> => state.bookingInfoStack.openedStack;
